<template>
  <div  v-if="show" class="scroll_wrapper">
    <a href="#" class="toPageTop" v-scroll-to="'body'">
      <img src="./assets/icon_pagetop.png" alt="上へ">
      <p>上へ</p>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.show = (window.scrollY > 150);
    });
  }
}
</script>

<style lang="scss">
.scroll_wrapper {
  display: none;

  // background-color: #E6E6E6;
  height: 64px;
  width: 52px;
  position: fixed;
  bottom: 66px;
  right: 25px;
  z-index: 99;

  @media all and (max-width: 767px) {
    display: inline;
  }
  .toPageTop{
    display: block;
    width: 60px;
    background-color: rgba(230,230,230,0.8);
    border-radius: 5px;
    text-decoration: none;
    >img{
      width: 30px;
      padding-top: 7.5px;
    }
    >p{
      border-radius: 5px;
      text-decoration: none;
      color: #000;
    }
  }
}
@media print {
  .scroll_wrapper {
    display: none;
  }
}
</style>